<template>
  <div
    class="zs-custom-select"
    :class="{ 'zs-custom-select-isCollapse': isCollapse, '_disabled': disabled }"
    :style="divWidth ? `width:${divWidth} !important` : ''"
  >
    <span
      class="zs-custom-select__item"
      v-for="(item, index) in value"
      :key="item"
    >
      {{ item }}
      <i v-if="!disabled" class="el-icon-close" @click="$emit('handleDelete', item, index)"></i>
    </span>
    <el-button class="zs-custom-select__btn" @click="change" v-if="value.length">
      {{ value.length }}
    </el-button>
    <i class="el-icon-search" @click="$emit('search')" v-if="!disabled && needSearch"></i>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    needSearch: {
      type: Boolean,
      default: true
    },
    divWidth: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isCollapse: true
    }
  },
  methods: {
    change() {
      this.isCollapse = !this.isCollapse
    }
  }
}
</script>

<style lang="scss">
.zs-custom-select:hover {
  border: 1px solid rgb(192, 192, 204);
}
.zs-custom-select {
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.1);
  //   height: 32px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 4px 10px;
  background: white;
  box-sizing: border-box;
  width: 400px;
  overflow: hidden;
  height: 90px;
  overflow: auto;
  padding-right: 50px;
  border-radius: 4px;
  .el-icon-close {
    cursor: pointer;
  }
  &._disabled{
    background-color: #F5F7FA;
    cursor: not-allowed;
  }
  &__item {
    height: 24px;
    background: #e4e8f2;
    border-radius: 2px;
    line-height: 24px;
    margin-right: 5px;
    text-align: center;
    margin-bottom: 5px;
    padding: 0 5px;
  }
  &__btn {
    position: absolute;
    right: 30px;
    top: 5px;
    padding: 0;
    text-align: center;
    line-height: 12px;
    border-radius: 12px;
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    font-size: 12px;
  }
  .el-icon-search {
    position: absolute;
    top: 8px;
    right: 10px;
    cursor: pointer;
    color: #C0C4CC;
  }
}
.zs-custom-select-isCollapse {
  height: 32px;
  overflow: hidden;
}
</style>
